import React, { Component } from 'react';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import '@progress/kendo-theme-default/dist/all.css';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { connect } from 'react-redux';
import {
	addDistrict,
	getAvailableCounties,
	deleteDistrict,
	updateDistrict
} from '../../../../../Redux/Actions/Admin/ManageDistrictActions';
import { Alert } from 'reactstrap';
import AdminHeader from '../../../AdminHeader/AdminHeader';
import cellWithEditing from '../ManageDistricts/CellWithEditing';
import DistrictForm from './DistrictForm';
import Search from '../../../Search';
import { fetchStates } from '../../../../../Redux/Actions/CommonActions';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import axios from 'axios';
import { DistrictLoader } from './DistrictLoader';
import { ROOT_API_URL } from '../../../../../api-config';
import { auth } from '../../../../../services/auth.service';

const FileDownload = require('js-file-download');

class ManageDistricts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isSubmitted: false,
            districtInEdit: {},
            isPopupVisible: false,
            districts: { data: [], total: 0 },
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters:[]
                },
                sort: [{ field: "DistrictNameNum", dir: "asc" }]
            },
            alertVisible: false,
            alertColor: "danger",
            alertMessage: ""
        };
    }

    componentDidMount() {
        this.props.fetchStates();
        this.props.getAvailableCounties();
    }

    dataStateChange = (e) => {
        if (e.data && e.data.filter && e.data.filter.filters) {
            var filters = e.data.filter.filters;

            for (var i = 0; i < filters.length; i++) {
                if (filters[i].value == null) {
                    filters[i].value = "";
                }
            }
        }

        this.setState({
            ...this.state,
            dataState: e.data
        });
    }

    dataRecieved = (districtsFetched) => {
        this.setState({
            ...this.state,
            districts: districtsFetched,
            isLoading: false
        });

        if (districtsFetched.total == 0 && document.getElementsByClassName("k-grid-header-wrap").length != 0) {
            let t = document.getElementsByClassName("k-grid-header-wrap")[0].className = "horizontal-scroll";
        }
        else if (districtsFetched.total != 0 && document.getElementsByClassName("horizontal-scroll").length != 0) {
            document.getElementsByClassName("horizontal-scroll")[0].className = "k-grid-header-wrap";
        }
    }

    edit = (dataItem) => {
        let model = {};
        model.districtId = dataItem.DistrictId;
        axios
            .post(`${ROOT_API_URL}/ManageDistrict/FetchCountiesForDistrict`, model, { headers: auth.authHeader() })
            .then((response) => {
                let t = {
                    districtId: dataItem.DistrictId,
                    description: dataItem.DistrictName,
                    assignedLoginId: dataItem.AssignedLoginId,
                    firstName: dataItem.FirstName,
                    lastName: dataItem.LastName,
                    countyList: response.data,
                    stateId: dataItem.StateId,
                    stateName: dataItem.StateName
                }

                this.setState({
                    districtInEdit: t,
                    isPopupVisible: true
                });
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to fetch counties for district.';

                this.setState({
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                })
            });     
    };

    cancel = () => {
        this.setState({ isPopupVisible: false })
    };

    stringifyObj = (arr) => {
        let t = [...arr];
        if (!t) {
            return null;
        }
        else {
            for (var i = 0; i < t.length; i++) {
                var element = { ...t[i] };
                for (var key in t[i]) {
                    element[key] = element[key] + '';
                }
                t[i] = element;
            }
            return t;
        }
    }

    exportToExcel = () => {
        var Filters = this.state.dataState.filter ? this.stringifyObj([...this.state.dataState.filter.filters]) : null;
        var Sorts = this.state.dataState.sort ? this.stringifyObj([...this.state.dataState.sort]) : null;
        var KendoGridQuery = {
            Filters: Filters ? Filters.slice() : [],
            Sorts: Sorts ? Sorts.slice() : []
        }

        axios.get(ROOT_API_URL + "/ManageDistrict/ExportToExcel?queryArguments=" + JSON.stringify(KendoGridQuery), { headers: auth.authHeader() })
            .then((response) => {
                FileDownload(response.data, 'Districts.csv');
            }).catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to export to excel.';

                this.setState({
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                })
            });  
    }

    toggleActive = (dataItem) => {
        dataItem.IsActive = !dataItem.IsActive;
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Description", dir: "asc" }]
            },
        });
        axios
            .post(`${ROOT_API_URL}/ManageDistrict/DeleteDistrict`, dataItem, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to delete the district.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            });  
    };

    addNew = () => {
        this.setState({
            isPopupVisible: true,
            districtInEdit: {}
        });
    }

    save = (model) => {
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: []
                },
                sort: [{ field: "DistrictName", dir: "asc" }]
            },
        });

        axios
            .post(`${ROOT_API_URL}/ManageDistrict/SaveDistrict`, model, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to save the district.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            });  
    }

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    }

    render() {
        return (
            <div id={"districts-grid"}>
                <AdminHeader />
                {this.state.isLoading ?
                    (<div>
                        <IsLoading message="Loading districts" />
                    </div>

                    ) :
                    (
                        <div>
                            <Alert
                                color={this.state.alertColor}
                                isOpen={this.state.alertVisible}
                                toggle={() => {
                                    this.setState({ alertVisible: false, alertMessage: "" })
                                }}
                            >
                                {this.state.alertMessage}
                            </Alert>
                            <Grid
                                style={{ width: '80vw', height: '80vh' }}
                                filterable={true}
                                sortable={true}
                                pageable={true}
                                total={this.state.districts.total}
                                {...this.state.dataState}
                                {...this.state.districts}
                                onDataStateChange={this.dataStateChange}
                                resizable
                                reorderable={true}
                            >
                                <GridToolbar>
                                    {/*<div className="admin-grid-toolbar-box1">
                                        <Search customFunc={this.filterSize} />
                                        <Switch
                                            // style="width:70px"
                                            filter="boolean"
                                            onChange={this.handleChange}
                                            onLabel={'Active'}
                                            offLabel={'InActive'}
                                            checked={this.state.toggled}
                                        />
                                    </div>*/}

                                    <div className="admin-grid-toolbar-box2">
                                        <button onClick={this.addNew} className="admin-k-button">
                                            <i className="fas fa-plus-circle"></i>
                                            <span>ADD NEW</span>
                                        </button>
                                        <a id="excel-ref" href={ROOT_API_URL + "/ManageDistricts/ExportToExcel"} display="none" download></a>
                                        <button title="Export PDF" className="admin-k-button" onClick={this.exportToExcel}>
                                            <i className="fas fa-file-export"></i>
                                            EXPORT TO EXCEL
                                        </button>
                                    </div>
                                </GridToolbar>
                                <Column filterable={false} cell={cellWithEditing(this.edit, this.toggleActive)} />
                                <Column field="DistrictNameNum" title="District Name" filter="numeric" />
                                <Column field="AssignedLoginId" title="Manager Email" filter="text" />
                                <Column field="FirstName" title="First Name" filter="text" />
                                <Column field="LastName" title="Last Name" filter="text" />
                                <Column field="Counties" title="Counties" filter="text" />
                            </Grid>
                        </div>
                    )
                }
                <div>
                    {!this.state.isSubmitted ?
                        <DistrictLoader
                            dataState={this.state.dataState}
                            onDataRecieved={this.dataRecieved}
                        />
                        : ""
                    }
                </div>
                <div>
                    {
                        this.state.isPopupVisible ? (
                            <DistrictForm
                                dataItem={this.state.districtInEdit}
                                save={this.save}
                                cancel={this.cancel}
                                addDistrict={this.props.addDistrict}
                                counties={this.props.district.counties}
                                updateDistrict={this.props.updateDistrict}
                                showToast={this.showToast}
                                states={this.props.common.states}
                            />
                        ) : ""
                    }
                </div>
            </div>

        );
    }
}

function mapStateToProps(state) {
	return {
		district: state.district,
		common: state.common
	};
}

export default connect(mapStateToProps, {
	fetchStates,
	addDistrict,
	getAvailableCounties,
	deleteDistrict,
	updateDistrict
})(ManageDistricts);
